import { encrypt } from '@/utils/rsa.js';
import { mapActions } from 'vuex';
import Captcha from './Captcha';
import LoginService from './LoginService';
export default {
  name: 'login-card',
  components: {
    Captcha,
    LoginService
  },
  data() {
    return {
      form: this.$form.createForm(this, {
        name: 'login'
      })
    };
  },
  methods: {
    ...mapActions({
      login: 'user/login'
    }),
    goRegister() {
      this.$emit('toggle-register');
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // const formData = new FormData();
          // formData.append('email', encrypt(values.email) || '');
          // formData.append('verify_code', values.code || '');
          let params = {
            email: values.email || '',
            verify_code: values.code || ''
          };
          await this.login(params);
        }
      });
    },
    async handleSendCaptcha() {
      const email = this.form.getFieldValue('email');
      if (email) {
        this.$http.login.sendCaptcha({
          email,
          is_login: true
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('验证码已发送至您的邮箱');
            this.$refs.captcha.countDown();
          }
        });
      } else {
        this.form.validateFields(['email'], () => {});
      }
    }
  }
};